import React from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath, faRulerCombined, faCalendarAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

// Sample property data (in a real app, this would come from an API)
const properties = [
  {
    id: 1,
    title: 'Modern Apartment with Ocean View',
    address: '123 Coastal Drive, Miami, FL',
    price: 450000,
    type: 'For Sale',
    bedrooms: 2,
    bathrooms: 2,
    area: 1200,
    yearBuilt: 2018,
    description: 'This beautiful modern apartment offers stunning ocean views from every room. Features include an open floor plan, high-end finishes, and a private balcony. The building offers amenities such as a pool, fitness center, and 24-hour security.',
    features: ['Central Air Conditioning', 'Hardwood Floors', 'Stainless Steel Appliances', 'Walk-in Closet', 'In-unit Laundry', 'Pet Friendly'],
    images: [
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    ]
  },
  {
    id: 2,
    title: 'Luxury Villa with Pool',
    address: '456 Palm Avenue, Los Angeles, CA',
    price: 1250000,
    type: 'For Sale',
    bedrooms: 4,
    bathrooms: 3.5,
    area: 3200,
    yearBuilt: 2015,
    description: 'Stunning luxury villa in a prime location. This property features a spacious open floor plan, gourmet kitchen, and resort-style backyard with pool and outdoor kitchen. Perfect for entertaining and family living.',
    features: ['Swimming Pool', 'Outdoor Kitchen', 'Smart Home System', 'Home Theater', 'Wine Cellar', '3-Car Garage'],
    images: [
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    ]
  },
  {
    id: 3,
    title: 'Downtown Loft',
    address: '789 Urban Street, New York, NY',
    price: 3500,
    type: 'For Rent',
    bedrooms: 1,
    bathrooms: 1,
    area: 950,
    yearBuilt: 2010,
    description: 'Stylish downtown loft in the heart of the city. Features exposed brick walls, high ceilings, and large windows with city views. Building amenities include a rooftop terrace, fitness center, and doorman.',
    features: ['Exposed Brick', 'High Ceilings', 'City Views', 'Doorman Building', 'Rooftop Access', 'Bike Storage'],
    images: [
      'https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1536376072261-38c75010e6c9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1505691938895-1758d7feb511?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
    ]
  }
];

const PropertyDetailPage = () => {
  const { id } = useParams();
  const property = properties.find(p => p.id === parseInt(id)) || properties[0];

  return (
    <div className="property-detail-page py-5">
      <div className="container">
        <div className="property-header mb-4">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h1 style={{ color: '#a87758' }}>{property.title}</h1>
              <p className="address">
                <FontAwesomeIcon icon={faMapMarkerAlt} /> {property.address}
              </p>
            </div>
            <div className="col-md-4 text-md-end">
              <div className="price" style={{ color: '#a87758' }}>${property.price.toLocaleString()}</div>
              <div className="property-type">{property.type}</div>
            </div>
          </div>
        </div>
        
        <div className="property-gallery mb-5">
          <div className="row">
            <div className="col-md-8">
              <img src={property.images[0]} alt={property.title} className="img-fluid main-image rounded" />
            </div>
            <div className="col-md-4">
              <div className="row">
                {property.images.slice(1, 4).map((image, index) => (
                  <div className="col-md-12 mb-3" key={index}>
                    <img src={image} alt={`${property.title} ${index + 1}`} className="img-fluid thumbnail rounded" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        <div className="property-details mb-5">
          <div className="row">
            <div className="col-md-8">
              <div className="card mb-4">
                <div className="card-body">
                  <h2 style={{ color: '#a87758' }}>Property Details</h2>
                  <div className="row property-features-icons my-4">
                    <div className="col-md-3 col-6 mb-3">
                      <div className="feature-item">
                        <FontAwesomeIcon icon={faBed} className="feature-icon" />
                        <div className="feature-text">
                          <span className="feature-value">{property.bedrooms}</span>
                          <span className="feature-label">Bedrooms</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="feature-item">
                        <FontAwesomeIcon icon={faBath} className="feature-icon" />
                        <div className="feature-text">
                          <span className="feature-value">{property.bathrooms}</span>
                          <span className="feature-label">Bathrooms</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="feature-item">
                        <FontAwesomeIcon icon={faRulerCombined} className="feature-icon" />
                        <div className="feature-text">
                          <span className="feature-value">{property.area}</span>
                          <span className="feature-label">Sq Ft</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="feature-item">
                        <FontAwesomeIcon icon={faCalendarAlt} className="feature-icon" />
                        <div className="feature-text">
                          <span className="feature-value">{property.yearBuilt}</span>
                          <span className="feature-label">Year Built</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <h3 style={{ color: '#a87758' }}>Description</h3>
                  <p>{property.description}</p>
                  
                  <h3 style={{ color: '#a87758' }}>Features</h3>
                  <ul className="property-features-list">
                    <div className="row">
                      {property.features.map((feature, index) => (
                        <div className="col-md-6" key={index}>
                          <li>{feature}</li>
                        </div>
                      ))}
                    </div>
                  </ul>
                </div>
              </div>
              
              <div className="card mb-4">
                <div className="card-body">
                  <h2 style={{ color: '#a87758' }}>Location</h2>
                  <div className="map-placeholder bg-light d-flex align-items-center justify-content-center" style={{ height: '300px' }}>
                    <p className="text-muted">Map will be displayed here</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="card mb-4">
                <div className="card-body">
                  <h3 style={{ color: '#a87758' }}>Contact Agent</h3>
                  <form>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">Name</label>
                      <input type="text" className="form-control" id="name" />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Email</label>
                      <input type="email" className="form-control" id="email" />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="phone" className="form-label">Phone</label>
                      <input type="tel" className="form-control" id="phone" />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="message" className="form-label">Message</label>
                      <textarea className="form-control" id="message" rows="4" defaultValue={`I'm interested in ${property.title}`}></textarea>
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Send Message</button>
                  </form>
                </div>
              </div>
              
              <div className="card">
                <div className="card-body">
                  <h3 style={{ color: '#a87758' }}>Schedule a Viewing</h3>
                  <div className="mb-3">
                    <label htmlFor="viewing-date" className="form-label">Date</label>
                    <input type="date" className="form-control" id="viewing-date" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="viewing-time" className="form-label">Time</label>
                    <input type="time" className="form-control" id="viewing-time" />
                  </div>
                  <button className="btn btn-outline-primary w-100">Request Viewing</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailPage;
